import { lighten } from "@mui/material";

// Theme Colours
export const terracotta = "#CB6843";
export const emeraldGreen = "#225729";
export const offWhite = "#F2F0EF";
export const deleteRed = "#D32F2F";
export const disabledText = "#9E9E9E";
export const grey = "#676F76";
export const white = "#FFFFFF";
export const textGrey = "#00000099";
export const cardBackground = "#FAFAFA";
export const textBoxGrey = "#F4F4F4";
export const bannerBackground = "#EDF7ED";

// Shadow Colours
export const boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.4)";
export const boxShadowHover = "0px 10px 18px rgba(0, 0, 0, 0.24)";
export const boxShadowCard = "5px 5px 6px rgba(0, 0, 0, 0.2)";
export const cardShadow =
  "0px 1px 2px 0px rgba(0,0,0,0.3), 0px 2px 6px 2px rgba(0,0,0,0.15)";

// Hover Colours
export const buttonHoverGrey = "#F0F0F0";
export const hoverTerracotta = lighten(terracotta, 0.9);
export const hoverSelectedTerracotta = lighten(terracotta, 0.1);
export const hoverDeleteRed = lighten(deleteRed, 0.9);
export const hoverEmeraldGreen = lighten(emeraldGreen, 0.9);
export const hoverSelectedEmeraldGreen = lighten(emeraldGreen, 0.1);
export const hoverGrey = lighten(grey, 0.9);

// Alert Colours
export const alertError = "#e39e84";
export const alertErrorLight = "#F3C5B4";
export const alertSuccess = "#91c498";
export const alertWarning = "#fff3e0"; //Light waring color
export const alertInfo = "#86b4db";

// Medical Navigator Theme Colours
export const mainThemeColours = {
  primary: { light: emeraldGreen, dark: "#4C9648" },
  secondary: { light: terracotta, dark: "#D07858" },
  error: { light: deleteRed, dark: "#FF6B6B" },
  background: { light: "#F3F1EF", dark: "#1E1E1E" },
  paper: { light: "#FFFFFF", dark: "#292929" },
  elevated: { light: "#FFFFFF", dark: "#3c3c3c" },
  text: { light: "#000000DE", dark: "#FFFFFF" },
  altText: { light: "#6B6B6B", dark: "#A9A9A9" },
};

// MBS
export const secondaryLinear = "#893017";
export const skeletonGradient = `linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.23), transparent)`;
